const ALLOWED_IMAGE_TYPES: ReadonlySet<string> = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
]);

const ACCEPTED_IMAGE_EXTENSIONS = 'image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp';

const MAX_IMAGE_SIZE_MB = 5;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

function isAllowedImageType(file: File): boolean {
  return ALLOWED_IMAGE_TYPES.has(file.type);
}

function validateImageFile(file: File, maxSizeMB: number = MAX_IMAGE_SIZE_MB): string | null {
  if (!ALLOWED_IMAGE_TYPES.has(file.type)) {
    return `File "${file.name}" has an unsupported type. Allowed types: JPEG, PNG, GIF, WEBP.`;
  }

  const maxBytes = maxSizeMB * 1024 * 1024;
  if (file.size > maxBytes) {
    return `File "${file.name}" exceeds ${maxSizeMB}MB limit.`;
  }

  if (file.size === 0) {
    return `File "${file.name}" is empty.`;
  }

  return null;
}

export {
  ALLOWED_IMAGE_TYPES,
  ACCEPTED_IMAGE_EXTENSIONS,
  MAX_IMAGE_SIZE_MB,
  MAX_IMAGE_SIZE_BYTES,
  isAllowedImageType,
  validateImageFile,
};
